import {
  SUBSCRIPTIONS_ALL,
  SUBSCRIPTIONS_ALL_SUCCESS,
  SUBSCRIPTIONS_CREATE,
  SUBSCRIPTIONS_CREATE_SUCCESS,
  SUBSCRIPTIONS_DELETE,
  SUBSCRIPTIONS_DELETE_SUCCESS,
  SUBSCRIPTIONS_GET,
  SUBSCRIPTIONS_GET_SUCCESS,
  SUBSCRIPTIONS_UPDATE,
  SUBSCRIPTIONS_UPDATE_SUCCESS
} from '../constants/Subscriptions';

const initialState = {
    subscription: {
      id: null,
      name: '',
      color: '',
    },
    subscriptions: null,
  }
  
  const subscriptions = (state = initialState, action) => {
    switch (action.type) {
      case SUBSCRIPTIONS_ALL:
        return {
          ...state,
        }
      case SUBSCRIPTIONS_ALL_SUCCESS:
        return {
          ...state,
          subscriptions: action.subscriptions,
        }
      case SUBSCRIPTIONS_GET:
        return {
          ...state,
        }
      case SUBSCRIPTIONS_GET_SUCCESS:
        return {
          ...state,
          subscription: action.subscription,
        }
      case SUBSCRIPTIONS_CREATE:
        return {
          ...state,
        }
      case SUBSCRIPTIONS_CREATE_SUCCESS:
        return {
          ...state,
          subscriptions: [
            ...state.subscriptions,
            action.subscription,
          ],
        }
      case SUBSCRIPTIONS_UPDATE:
        return {
          ...state,
        }
      case SUBSCRIPTIONS_UPDATE_SUCCESS:
        return {
          ...state,
          subscription: action.subscription,
          subscriptions: state.subscriptions.map(t => {
            if (action.subscription.id === t.id) {
              return action.subscription;
            }
            return t;
          })
        }
      case SUBSCRIPTIONS_DELETE:
        return {
          ...state,
        }
      case SUBSCRIPTIONS_DELETE_SUCCESS:
        return {
          ...state,
          subscriptions: state.subscriptions
            ? state.subscriptions.filter(t => t.id !== action.subscriptionId)
            : [],
        }
      default:
        return state;
    }
  }
  
  export default subscriptions;